import React, { Component } from 'react';
import { Scoped, a } from 'kremling';
import { string, func, object } from 'prop-types';
import { Icon } from '../icon/icon.component';
import Button from '@mui/material/Button';
import styles from './page-header-mui.scss';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import CloseIcon from '@mui/icons-material/Close';
import { withStyles } from '@mui/styles';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import { snackbarService } from 'components/mui/snackbar/snackbar-service';
import { Badge, Divider, Grid2, InputAdornment, Tooltip } from '@mui/material';
import Popper from '@mui/material/Popper';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Paper from '@mui/material/Paper';
import Avatar from '@mui/material/Avatar';
import { NavLink } from 'react-router-dom';
import { addUserToLaunchDarklySegment, getCompanies, getFolder, getNotificationLogs, removeUserFromLaunchDarklySegment } from 'shared/common.api';
import { useContext } from 'react';
import { UserStateContext } from 'context/user-state-context';
import { NotificationsContext } from 'context/notifications-context';
import validator from 'validator';
import { useLocation, useHistory } from 'react-router-dom';
import { AddRoadIcon, CallIcon, CompanyIcon, CustomersIcon, DataFieldsIcon, DomainIcon, EjectIcon, IntegrationsIcon, LocationOnIcon, LogoutIcon, MarketingIcon, MarketsIcon, RolesIcon, SettingsIcon, NotificationsIcon, TransactionIcon, ShieldPersonIcon, HandymanIcon, SmartToyIcon, VisibilityIcon, VisibilityOffIcon } from 'components/mui';
import { Loader } from 'components/loader/loader.component';
import CONSTANTS from 'shared/constants';
import { SocketContext } from 'context/socket-context';
const RoundedTextField = withStyles({
  root: {
    '& .MuiOutlinedInput-root': {
      borderRadius: `14px`
    }
  }
})(TextField);
const SearchTextField = withStyles({
  root: {
    '& .MuiOutlinedInput-root': {
      'backgroundColor': '#F1F3F4',
      'borderRadius': `20px`,
      '& fieldset': {
        border: 'none'
      }
    }
  }
})(TextField);

/**
 * A custom Modal Component that can be used to display a modal-dialog with custom props.
 *
  @param {string} name - The name to display after the Parent page type. This is likely the Current Page name. "Parent Page Type > Name"
  @param {string} type - The Parent page type to display in the header. "Type > Current Page Name"
  @param {string} namePrefix - The name prefix to display in the header. This will display between the parent page and the current page name. "Parent Page > Name Prefix > Current Page Name"
  @param {string} namePrefixAction - The action to take when the name prefix is clicked. This should be used with the namePrefix prop and likely history.push()
  @param {string} icon - The icon to display in the header.
  @param {string} objIcon - The object icon to display in the header.
  @param {string} displayComponent - Used to override the default component. This should be used with the type prop.
  @param {string} breadcrumbOverride - Used to override the default name. This should be used with the breadcrumbOverrideURL prop and breadcrumbOverrideName prop.
  @param {string} breadcrumbOverrideURL - Used to override the default URL. This should be used with the breadcrumbOverride prop and breadcrumbOverrideName prop.
  @param {string} breadcrumbOverrideName - Used to override the default name. This should be used with the breadcrumbOverrideURL prop and breadcrumbOverride prop.
  @param {string} typeHistoryOverride - Used to override the default history. This should be used with the type prop.
  @param {string} folderBreadcrumbs - Used to display the folder breadcrumbs. This should be used with the folderData prop.
  @param {string} updateName() - The function to call when the name is updated. You must pass in a function that updates the name.
  @param {boolean} updateNamePermission - The permission to update the name.

 */

export const PageHeaderMui = props => {
  const {
    asCompany,
    hasPermission,
    setAsCompany,
    user,
    logOut,
    hasIntegration,
    flags,
    isCatalystUser,
    isLoadingUserStateApis,
    isLoadingFlags,
    companies,
    isPLG,
    impersonatingAsCustomer,
    setImpersonatingAsCustomer
  } = useContext(UserStateContext);
  const {
    toggleEnabled
  } = useContext(SocketContext);
  const {
    newCount
  } = useContext(NotificationsContext);
  const [editVal, setEditVal] = React.useState('');
  const [editName, setEditName] = React.useState(false);
  const [settingsAnchorEl, setSettingsAnchorEl] = React.useState(null);
  const settingsOpen = Boolean(settingsAnchorEl);
  const [settingsMenu, setSettingsMenu] = React.useState([]);
  const [notificationsAnchorEl, setNotificationsAnchorEl] = React.useState(null);
  const notificationsOpen = Boolean(notificationsAnchorEl);
  const [notifications, setNotifications] = React.useState([]);
  const [notificationsLoading, setNotificationsLoading] = React.useState(false);
  const [companiesAnchorEl, setCompaniesAnchorEl] = React.useState(null);
  const companiesOpen = Boolean(companiesAnchorEl);
  const [companiesSearch, setCompaniesSearch] = React.useState('');
  const [folderData, setFolderData] = React.useState();
  const history = useHistory();
  const {
    search
  } = useLocation();
  const searchParams = new URLSearchParams(search);
  const folderParam = searchParams.get('folder');
  const [avatarHover, setAvatarHover] = React.useState(null);
  const [backdrop, setBackdrop] = React.useState(false);
  const [recentlyUsedCompanies, setRecentlyUsedCompanies] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(false);
  const [breadcrumbOverride, setBreadcrumbOverride] = React.useState(null);
  const isSuperuser = !!user?.is_superuser;

  // Superusers are not preloaded in context (their company list is something like limit 9999), so they keep
  // debounced server-side search here. Normal users filter the once-loaded `companies` list in JS.
  const [superuserResults, setSuperuserResults] = React.useState([]);
  const [superuserCount, setSuperuserCount] = React.useState(0);
  React.useEffect(() => {
    if (!isSuperuser || !user?.id) return;
    let active = true;
    const timeout = setTimeout(() => {
      getCompanies({
        search: companiesSearch,
        view: 'quick',
        is_active: true,
        limit: 50
      }).then(({
        data
      }) => {
        if (!active) return;
        setSuperuserResults(data.results);
        setSuperuserCount(data.count);
      }).catch(() => {
        // Leave the previously loaded list in place on failure.
      });
    }, 300);
    return () => {
      active = false;
      clearTimeout(timeout);
    };
  }, [isSuperuser, user?.id, companiesSearch]);

  // The list rendered in the switcher: server results for superusers, JS-filtered list otherwise.
  const filteredCompanies = React.useMemo(() => {
    if (isSuperuser) return superuserResults;
    const q = companiesSearch.trim().toLowerCase();
    return q ? companies.filter(company => company.name?.toLowerCase().includes(q)) : companies;
  }, [isSuperuser, superuserResults, companies, companiesSearch]);
  const companiesCount = isSuperuser ? superuserCount : filteredCompanies.length;
  React.useEffect(() => {
    if (CONSTANTS.ENV === 'LOCAL') {
      setRecentlyUsedCompanies(localStorage.getItem('recentlyUsedCompaniesLocal') ? JSON.parse(localStorage.getItem('recentlyUsedCompaniesLocal')) : []);
    } else if (CONSTANTS.ENV === 'DEV') {
      setRecentlyUsedCompanies(localStorage.getItem('recentlyUsedCompaniesDev') ? JSON.parse(localStorage.getItem('recentlyUsedCompaniesDev')) : []);
    } else {
      setRecentlyUsedCompanies(localStorage.getItem('recentlyUsedCompanies') ? JSON.parse(localStorage.getItem('recentlyUsedCompanies')) : []);
    }
  }, []);
  React.useEffect(() => {
    if (isLoadingUserStateApis || isLoadingFlags) return;
    setSettingsMenu([{
      key: '/companies/' + asCompany.id,
      name: 'Company',
      icon: CompanyIcon,
      enabled: true
    }, {
      key: '/locations',
      name: 'Locations',
      icon: LocationOnIcon,
      enabled: hasPermission('organization.view_location') && !isCatalystUser
    }, {
      key: '/integrations',
      name: 'Integrations',
      icon: IntegrationsIcon,
      enabled: hasPermission('integration.view_credential') && !isCatalystUser && !isPLG
    }, {
      key: '/domains',
      name: 'Domains',
      icon: DomainIcon,
      enabled: hasPermission('email.view_domain') && !isCatalystUser && !isPLG
    }, {
      key: '/users',
      name: 'Users',
      icon: CustomersIcon,
      enabled: hasPermission('authentication.view_user') && !isCatalystUser
    }, {
      key: isPLG ? '/notification-recipients' : '/notification-list',
      name: 'Notification List',
      icon: CustomersIcon,
      enabled: hasPermission('authentication.view_user') && hasIntegration('notification_list') && !isCatalystUser
    }, {
      key: '/roles',
      name: 'Roles',
      icon: RolesIcon,
      enabled: hasPermission('auth.view_group') && !isCatalystUser && !isPLG
    }, {
      key: '/phone-numbers',
      name: 'Phone Numbers',
      icon: CallIcon,
      enabled: hasPermission('communication.view_phonenumber') && !isCatalystUser
    }, {
      key: '/data-fields',
      name: 'Data Fields',
      icon: DataFieldsIcon,
      enabled: hasPermission('organization.view_company') && !isCatalystUser && !isPLG
    }, {
      key: '/billing',
      name: 'Billing',
      icon: TransactionIcon,
      enabled: hasPermission('organization.view_billing') && (flags?.billing && !isCatalystUser || isPLG)
    }, {
      key: 'ai-box',
      name: 'Cinch AI',
      icon: SmartToyIcon,
      enabled: flags?.ai_chat_bot && !isCatalystUser && !isPLG,
      onClick: () => {
        handleSettingsClose();
        toggleEnabled();
      }
    }, {
      key: '/admin',
      name: 'Admin',
      icon: HandymanIcon,
      enabled: (user.is_superuser || flags.cinch_testers) && !isCatalystUser && !isPLG
    }, {
      key: '/employee-portal/request-access',
      name: 'Employee Portal',
      icon: ShieldPersonIcon,
      enabled: flags.employee_portal && user?.email && user.email.endsWith('@cinch.io') && !isCatalystUser && !isPLG
      //badge: 1,
    }, {
      key: '/community',
      name: flags?.user_is_in_ld_beta_segment ? 'Roadmap & Feedback (Beta)' : 'Roadmap & Feedback',
      icon: MarketingIcon,
      enabled: flags.roadmapAndFeedback && !isCatalystUser && !isPLG
    }, {
      key: 'beta',
      name: flags?.user_is_in_ld_beta_segment || user.email?.endsWith('@cinch.io') ? 'Leave Cinch Beta' : 'Join Cinch Beta',
      icon: flags?.user_is_in_ld_beta_segment || user.email?.endsWith('@cinch.io') ? EjectIcon : AddRoadIcon,
      enabled: !isCatalystUser && !isPLG,
      disabled: user.email?.endsWith('@cinch.io'),
      //the beta item is always shown, but is disabled if the user is using a cinch.io email because they are always opted into the beta
      onClick: () => {
        if (user.email?.endsWith('@cinch.io')) {
          return;
        }
        handleSettingsClose();
        //setIsLoading(true);
        if (flags?.user_is_in_ld_beta_segment) {
          removeUserFromLaunchDarklySegment({
            segment_key: 'beta'
          }).then(({
            data
          }) => {
            // window.location.reload();
            snackbarService.popup({
              type: 'success',
              message: 'You have been removed from Cinch Beta. This may take a few hours to apply.'
            });
          });
        } else {
          addUserToLaunchDarklySegment({
            segment_key: 'beta'
          }).then(({
            data
          }) => {
            // window.location.reload();

            snackbarService.popup({
              type: 'success',
              message: 'You have been added to Cinch Beta. This may take a few hours to apply.'
            });
          });
        }
      }
    }, {
      key: 'impersonate-as-customer',
      name: impersonatingAsCustomer ? 'Exit user view' : 'View as PLG user',
      icon: impersonatingAsCustomer ? VisibilityOffIcon : VisibilityIcon,
      // Superuser-only; scoped to PLG accounts for now — expand supported account types
      // here (and in `isPLG`) when extending impersonation to other segments.
      enabled: user?.is_superuser && asCompany?.account_type === 'PLG',
      onClick: () => {
        setImpersonatingAsCustomer(!impersonatingAsCustomer);
        handleSettingsClose();
      }
    }, {
      key: 'logout',
      name: 'Sign out',
      icon: LogoutIcon,
      enabled: true,
      onClick: () => logOut()
    }]);
  }, [hasPermission, asCompany?.id, asCompany?.account_type, flags, !!isCatalystUser, isLoadingUserStateApis, isLoadingFlags, isPLG, impersonatingAsCustomer]);
  React.useEffect(() => {
    if (props.folderBreadcrumbs && folderParam && validator.isUUID(folderParam)) {
      getFolder(folderParam).then(({
        data
      }) => {
        setFolderData(data);
      });
    } else {
      setFolderData(null);
    }
    const queryParams = new URLSearchParams(window.location.search);
    if (queryParams.get('breadcrumbOverrideURL') && queryParams.get('breadcrumbOverrideName')) {
      setBreadcrumbOverride({
        url: queryParams.get('breadcrumbOverrideURL'),
        name: queryParams.get('breadcrumbOverrideName')
      });
    }
  }, [folderParam, props.folderBreadcrumbs, editVal]);
  const handleSaveEdit = (old, restore) => {
    props.updateName(restore ? old : {
      id: old.id,
      name: editVal
    });
    setEditName(false);
    if (props.folderBreadcrumbs && folderParam && validator.isUUID(folderParam)) {
      getFolder(folderParam).then(({
        data
      }) => {
        setFolderData(data);
      });
    }
  };
  const handleEditName = () => {
    if (props.updateNamePermission) {
      setEditName(true);
      setEditVal(props.folderBreadcrumbs && folderData ? folderData.path[folderData.path.length - 1].name : props.name);
    }
  };
  const handleSnackbarUndo = old => {
    const undoName = editVal;
    setEditVal(old.name);
    handleSaveEdit(old, true);
    snackbarService.close();
    snackbarService.popup({
      message: `"${undoName}" changed back to "${old.name}"`,
      action: <React.Fragment>
          <IconButton size="small" color="white" onClick={() => snackbarService.close()}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </React.Fragment>
    });
  };
  const handleSnackbar = old => {
    snackbarService.popup({
      message: '"' + old.name + '" changed to "' + editVal + '"',
      action: <React.Fragment>
          <Button size="small" onClick={e => handleSnackbarUndo(old)}>
            <Typography sx={{
            textTransform: 'none',
            color: '#53A6D6'
          }}>Undo</Typography>
          </Button>
          <IconButton size="small" color="white" onClick={() => snackbarService.close()}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </React.Fragment>
    });
  };
  const handleSettingsClose = () => {
    setSettingsAnchorEl(null);
  };
  const handleSettingsOpen = event => {
    setSettingsAnchorEl(settingsOpen ? null : event.currentTarget);
  };
  const handleNotificationsClose = () => {
    setNotificationsAnchorEl(null);
  };
  const handleNotificationsOpen = event => {
    const opening = !notificationsOpen;
    setNotificationsAnchorEl(notificationsOpen ? null : event.currentTarget);
    if (opening) {
      setNotificationsLoading(true);
      getNotificationLogs({
        company: asCompany?.id,
        limit: 10
      }).then(({
        data
      }) => setNotifications(data.results)).catch(() => {}).finally(() => setNotificationsLoading(false));
    }
  };
  const handleSaveClick = old => {
    handleSnackbar(old);
    handleSaveEdit(old);
  };
  const handleCompaniesOpen = event => {
    setCompaniesAnchorEl(companiesOpen ? null : event.currentTarget);
  };
  const handleCompaniesClose = () => {
    setCompaniesSearch('');
    setCompaniesAnchorEl(null);
  };
  const getInitals = name => {
    if (name) return name.split(' ').filter((segment, i) => i < 2).map(segment => segment[0]).join('').toUpperCase();
  };
  const handleSnackbarClose = () => {
    snackbarService.close();
    setBackdrop(false);
  };
  const handleCompanyChange = comp => {
    if (asCompany.id != comp.id) {
      setBackdrop(true);
      setAsCompany(comp);
      handleCompaniesClose();
      handleRecentlyUsedCompanies(comp);
      let newurl = null;
      const path = window?.location?.pathname.split('/');
      for (var i = 0; i < path.length; i++) {
        if (validator.isUUID(path[i])) {
          newurl = '/' + path[1];
        }
      }
      history.push('/dashboard', {
        previousPage: newurl || window.location.pathname
      });
      snackbarService.popup({
        horizontal: 'center',
        middle: 1,
        duration: 600000,
        message: <Stack spacing={3}>
            <Stack spacing={1}>
              <Box sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              px: '200px'
            }}>
                <Typography sx={{
                color: '#fff'
              }}>You are now working as </Typography>
              </Box>
              <Box sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
                <Typography sx={{
                color: '#fff',
                fontSize: 24
              }}>{comp.name} </Typography>
              </Box>
            </Stack>

            <Box sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}>
              {props?.type && props.type != 'Dashboard' && history.location.state?.previousPage ? <Box sx={{
              px: 2
            }}>
                  <Button onClick={e => {
                const oldPath = history.location.state?.previousPage;
                history.push({
                  pathname: oldPath
                });
                handleSnackbarClose();
              }}>
                    <Typography sx={{
                  color: '#53A6D6',
                  textTransform: 'none'
                }}>{'Go to ' + props?.type}</Typography>
                  </Button>
                </Box> : <Box sx={{
              px: '150px'
            }}></Box>}

              <Box sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
                <Button onClick={e => handleSnackbarClose()}>
                  <Typography sx={{
                  color: '#a1aab3',
                  textTransform: 'capitalize'
                }}>Continue to Dashboard</Typography>
                </Button>
              </Box>
            </Box>
          </Stack>
      });
    }
  };
  const reset = () => {
    setCompaniesSearch('');
  };
  const handleBreadcrumbClick = folderId => {
    if (props.folderBreadcrumbs) {
      const queryParams = new URLSearchParams(window.location.search);
      if (queryParams.get('folder') != folderId) {
        if (folderId != '') {
          queryParams.set('folder', folderId);
        } else {
          queryParams.delete('folder');
        }
        const newurl = window.location.pathname + '?' + queryParams.toString();
        history.push(newurl);
      }
    } else if (props?.typeHistoryOverride) {
      history.push(props.typeHistoryOverride);
    } else {
      const path = window?.location?.pathname.split('/');
      history.push({
        pathname: '/' + path[1]
      });
    }
  };
  const handleRecentlyUsedCompanies = comp => {
    let recents = recentlyUsedCompanies;
    if (recents.indexOf(comp) == -1) {
      if (recents.length == 3) {
        recents.pop();
      }
      recents.unshift(comp);
      if (CONSTANTS.ENV === 'LOCAL') {
        localStorage.setItem('recentlyUsedCompaniesLocal', JSON.stringify(recents));
      } else if (CONSTANTS.ENV === 'DEV') {
        localStorage.setItem('recentlyUsedCompaniesDev', JSON.stringify(recents));
      } else {
        localStorage.setItem('recentlyUsedCompanies', JSON.stringify(recents));
      }
      setRecentlyUsedCompanies(recents);
    }
  };
  document.title = props.type ? props.type + ' - Cinch' : 'Cinch';
  return <>
      {isLoading && <Loader overlay background="#e4e9f1" />}
      <Scoped css={styles}>
        <div id="page-header" className="page-header secondary-color" style={{
        px: '20px',
        height: '64px'
      }}>
          <Box sx={{
          display: 'flex',
          width: '100%'
        }} className="d-flex w-100 justify-content-between">
            {props?.displayComponent ? <>{props.displayComponent}</> : <Box sx={{
            display: 'flex'
          }} className="d-flex justify-content-between">
                <Stack sx={{
              pl: '16px'
            }} direction="row">
                  <Box sx={{
                py: 1,
                color: 'black',
                fontSize: 40
              }}>
                    {props.icon}
                  </Box>

                  {!!breadcrumbOverride && <Typography onClick={() => {
                history.push(breadcrumbOverride?.url);
              }} noWrap sx={{
                'fontFamily': 'Nexa',
                'maxWidth': 'calc(85vw - 70rem)',
                'lineHeight': '30px',
                'fontSize': 24,
                'color': '#1D252D',
                'textAlign': 'center',
                'margin': 'auto',
                'pl': 1,
                'opacity': '0.6',
                'cursor': 'pointer',
                ':hover': {
                  backgroundColor: '#DAEFFF',
                  color: '#53A6D6'
                }
              }}>
                      {breadcrumbOverride?.name} &gt;
                    </Typography>}
                  <Tooltip title={props.type}>
                    <Typography onClick={() => {
                  handleBreadcrumbClick('');
                }} noWrap sx={{
                  'fontFamily': 'Nexa',
                  'lineHeight': '30px',
                  'fontSize': 24,
                  'maxWidth': !!props?.namePrefix || !!props?.folderBreadcrumbs?.length > 0 || !!props?.name ? 'calc(85vw - 70rem)' : null,
                  'color': '#1D252D',
                  'textAlign': 'center',
                  'margin': 'auto',
                  'pl': 1,
                  'opacity': props.name ? '0.6' : '1',
                  'cursor': 'pointer',
                  ':hover': {
                    backgroundColor: props.folderBreadcrumbs && folderParam ? '#DAEFFF' : '#fff',
                    color: props.folderBreadcrumbs && folderParam ? '#53A6D6' : '#1D252D'
                  }
                }}>
                      {props.type}
                    </Typography>
                  </Tooltip>
                  {props.folderBreadcrumbs && folderData && folderData.path.map((f, index) => <Tooltip title={f.name}>
                        <Typography key={f.id} onClick={() => {
                  handleBreadcrumbClick(f.id);
                }} noWrap sx={{
                  'maxWidth': 'calc(85vw - 70rem)',
                  'fontFamily': 'Nexa',
                  'fontSize': 24,
                  'lineHeight': '30px',
                  'color': '#1D252D',
                  'textAlign': 'center',
                  'margin': 'auto',
                  'pl': 1,
                  'opacity': '0.6',
                  'cursor': 'pointer',
                  ':hover': {
                    backgroundColor: '#DAEFFF',
                    color: '#53A6D6'
                  }
                }}>
                          &gt; {index == folderData.path.length - 1 ? f.name : '' + f.name.slice(0, 8) + '...'}
                        </Typography>
                      </Tooltip>)}

                  {!!props.namePrefix && <Tooltip title={props.namePrefix}>
                      <Typography onClick={() => {
                  props.namePrefixAction();
                }} noWrap sx={{
                  'maxWidth': 'calc(85vw - 70rem)',
                  'display': 'flex',
                  'alignItems': 'center',
                  'justifyContent': 'left',
                  'fontFamily': 'Nexa',
                  'fontSize': 24,
                  'lineHeight': '30px',
                  'color': '#1D252D',
                  'textAlign': 'center',
                  'margin': 'auto',
                  'pl': 1,
                  'cursor': 'pointer',
                  ':hover': {
                    backgroundColor: '#DAEFFF',
                    color: '#53A6D6'
                  }
                }}>
                        &gt; {props.namePrefix}
                      </Typography>
                    </Tooltip>}

                  {(props.name || !('updateNamePermission' in props) || props.updateNamePermission) && <Stack direction="row" sx={{
                alignItems: 'center',
                gap: '12px'
              }}>
                      {props.name && <Box>
                          <Typography sx={{
                    fontFamily: 'Nexa',
                    fontSize: 24,
                    lineHeight: '30px',
                    color: '#1D252D',
                    textAlign: 'center',
                    margin: 'auto',
                    pl: 1,
                    opacity: '0.6'
                  }}>
                            &gt;
                          </Typography>
                        </Box>}
                      <Box>{props.objIcon}</Box>
                      {props.name && <Tooltip title={props.name}>
                          <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'left'
                  }}>
                            <Typography noWrap sx={{
                      maxWidth: 'calc(85vw - 95rem)',
                      fontFamily: 'Nexa',
                      fontSize: 24,
                      lineHeight: '30px',
                      color: '#1D252D',
                      textAlign: 'center',
                      maxHeight: '48px',
                      minHeight: '28px',
                      cursor: props.updateNamePermission ? 'pointer' : 'default'
                    }} onClick={handleEditName}>
                              {props.name}
                            </Typography>
                          </Box>
                        </Tooltip>}
                      {'updateName' in props && props.updateNamePermission && <Box onClick={handleEditName} sx={{
                  cursor: 'pointer'
                }}>
                          <Icon name="custom-pencil" size={24} />
                        </Box>}
                    </Stack>}
                </Stack>
              </Box>}
          </Box>
          <Stack spacing={2} sx={{
          pl: '16px',
          alignItems: 'center'
        }} direction="row">
            <Box>
              <Stack spacing={1} sx={{
              pl: '16px',
              alignItems: 'center'
            }} direction="row">
                <Box>
                  <Icon name="custom-contacts" size={24} />
                </Box>
                <Typography variant="tableHeader" sx={{
                minWidth: '85px'
              }}>
                  Working as:
                </Typography>
                <Box sx={{
                cursor: 'pointer',
                borderRadius: '8px',
                alignItems: 'center',
                display: 'flex',
                height: '40px',
                width: '266px',
                backgroundColor: companiesOpen ? '#DAEFFF' : '#FFFFFF'
              }} onClick={handleCompaniesOpen}>
                  <Stack sx={{
                  display: 'flex',
                  flexGrow: 1
                }} direction="row">
                    <Box sx={{
                    px: '12px'
                  }}>
                      <Avatar sx={{
                      height: '30px',
                      width: '30px'
                    }}>{getInitals(asCompany?.name)}</Avatar>
                    </Box>
                    <Box sx={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    width: '180px',
                    alignItems: 'center',
                    alignContent: 'center',
                    display: 'flex'
                  }}>
                      <Typography id="workingAsCompanyName" sx={{
                      color: '#616161F2'
                    }} noWrap>
                        {asCompany?.name}
                      </Typography>
                    </Box>
                    <Box sx={{
                    flexGrow: 1
                  }} />
                    {companiesOpen ? <Box sx={{
                    pl: '18px',
                    position: 'relative',
                    transform: 'rotate(180deg)',
                    bottom: '5px'
                  }}>
                        <Icon name="custom-keyboard-arrow-down" />
                      </Box> : <Box sx={{
                    pr: '18px',
                    position: 'relative',
                    top: '5px'
                  }}>
                        <Icon name="custom-keyboard-arrow-down" />
                      </Box>}
                  </Stack>
                </Box>
              </Stack>
            </Box>
            <Divider sx={{
            minHeight: '24px'
          }} orientation="vertical" />
            {flags?.notifications && <Box>
                <Tooltip title="Notifications">
                  <IconButton sx={{
                'width': '36px',
                'height': '36px',
                'textAlign': 'center',
                'padding': 0,
                'backgroundColor': notificationsOpen ? '#DAEFFF' : '#fff',
                'color': notificationsOpen ? '#53A6D6' : '#1D252D',
                ':hover': {
                  backgroundColor: '#DAEFFF',
                  color: '#53A6D6'
                }
              }} onClick={handleNotificationsOpen}>
                    <Badge sx={{
                  '& .MuiBadge-badge': {
                    color: '#ffffff',
                    backgroundColor: '#E35989'
                  }
                }} badgeContent={newCount} invisible={!newCount} max={99}>
                      <NotificationsIcon fill="#1D252D" />
                    </Badge>
                  </IconButton>
                </Tooltip>
              </Box>}
            <Box sx={{
            pr: '20px'
          }}>
              <Tooltip title={impersonatingAsCustomer ? 'Viewing as user — click to open settings' : 'Settings'}>
                <IconButton sx={{
                'width': '36px',
                'height': '36px',
                'textAlign': 'center',
                'padding': 0,
                'backgroundColor': settingsOpen ? '#DAEFFF' : '#fff',
                'color': settingsOpen ? '#53A6D6' : '#1D252D',
                ':hover': {
                  backgroundColor: '#DAEFFF',
                  color: '#53A6D6'
                }
              }} onClick={handleSettingsOpen}>
                  <Badge variant="dot" overlap="circular" anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right'
                }} sx={{
                  '& .MuiBadge-badge': {
                    color: '#ffffff',
                    backgroundColor: '#F5A623'
                  }
                }} invisible={!impersonatingAsCustomer}>
                    <SettingsIcon fill="#1D252D" />
                  </Badge>
                </IconButton>
              </Tooltip>
            </Box>
          </Stack>
        </div>

        <Dialog PaperProps={{
        style: {
          borderRadius: '28px',
          width: '400px'
        }
      }} open={editName} onClose={() => {
        setEditName(false);
      }}>
          <DialogTitle sx={{
          m: 0,
          p: 2,
          fontSize: 'medium'
        }}>
            <Stack alignItems="center" component="span">
              <Typography variant="h4" component="span">
                Edit Name
              </Typography>
            </Stack>
          </DialogTitle>
          <DialogContent dividers>
            <DialogContentText>
              <Box component="span">
                <RoundedTextField sx={{
                width: '100%'
              }} label={!editVal || editVal === '' ? 'Name' : ''} focused autoFocus onFocus={event => {
                event.target.select();
              }} hiddenLabel value={editVal} onChange={e => setEditVal(e.target.value)} onKeyPress={e => {
                if (e.key === 'Enter' && props.name != editVal && editVal != '') {
                  handleSaveClick(props.folderBreadcrumbs && folderData ? folderData.path[folderData.path.length - 1] : {
                    name: props.name
                  });
                }
              }} />
              </Box>
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{
          py: 1
        }}>
            <Button onClick={() => {
            setEditName(false);
          }} variant="text" sx={{
            borderRadius: '20px',
            color: 'rgba(29, 37, 45, 0.7)',
            width: '75px'
          }}>
              Cancel
            </Button>
            <Button disabled={props.name == editVal || editVal == ''} onClick={() => {
            handleSaveClick(props.folderBreadcrumbs && folderData ? folderData.path[folderData.path.length - 1] : {
              name: props.name
            });
          }} variant="text" sx={{
            mr: 1,
            borderRadius: '20px',
            width: '75px',
            color: '#53A6D6'
          }}>
              Save
            </Button>
          </DialogActions>
        </Dialog>

        <Popper anchorEl={companiesAnchorEl} sx={{
        zIndex: 200
      }} open={companiesOpen} onClose={handleCompaniesClose} placement="bottom">
          <ClickAwayListener onClickAway={handleCompaniesClose}>
            <Paper elevation={0} sx={{
            'borderRadius': '16px',
            'overflow': 'visible',
            'width': '266px',
            'overflowY': 'scroll',
            'maxHeight': '66vh',
            'scrollbarWidth': 'thin',
            '&::-webkit-scrollbar': {
              width: '0.4em'
            },
            '&::-webkit-scrollbar-track': {
              background: '#f1f1f1',
              marginTop: '20px',
              marginBottom: '20px'
            },
            '&::-webkit-scrollbar-thumb': {
              backgroundColor: '#888'
            },
            '&::-webkit-scrollbar-thumb:hover': {
              background: '#555'
            },
            'filter': 'drop-shadow(0px 0px 4px rgba(0,0,0,0.25))',
            'mt': 1.5,
            '& .MuiAvatar-root': {
              width: 30,
              height: 30
            },
            '&:before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: 'background.paper',
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 200
            }
          }}>
              <Box sx={{
              pb: 1
            }}>
                <Box sx={{
                pt: 1,
                position: 'sticky',
                top: '0px',
                backgroundColor: '#fff',
                zIndex: 205
              }}>
                  <Grid2 container justifyContent="center" sx={{
                  pb: 1
                }}>
                    <Box sx={{
                    px: 1,
                    width: '100%'
                  }}>
                      <SearchTextField placeholder="Search companies" fullWidth autoFocus sx={{
                      height: '40px'
                    }} value={companiesSearch} onChange={e => {
                      setCompaniesSearch(e.target.value);
                    }} InputProps={{
                      startAdornment: <InputAdornment position="start">
                              <Icon name="custom-search" />
                            </InputAdornment>,
                      endAdornment: !!companiesSearch && <InputAdornment onClick={reset} position="start" sx={{
                        cursor: 'pointer'
                      }}>
                              <CloseIcon />
                            </InputAdornment>
                    }} />
                    </Box>
                  </Grid2>
                  {companiesCount > 1 && <Stack sx={{
                  pt: 2,
                  pl: 2
                }}>
                      {companiesCount > 10 && <Typography> Showing first 10 of {companiesCount}</Typography>}

                      <Button sx={{
                    textTransform: 'none',
                    display: 'flex',
                    justifyContent: 'left'
                  }} onClick={e => {
                    history.push('/companies');
                  }}>
                        View All Companies
                      </Button>
                    </Stack>}
                  {!companiesSearch && companiesCount > 5 && recentlyUsedCompanies.length > 0 && <>
                      <Divider flexItem sx={{
                    pt: 2
                  }} />
                      <Stack>
                        <Box sx={{
                      py: 1,
                      pl: 1
                    }}> Recently Used Companies</Box>
                        {recentlyUsedCompanies.map((company, index) => <Button disabled={asCompany.id == company} onMouseEnter={e => setAvatarHover(company)} onMouseLeave={e => setAvatarHover(null)} onClick={() => {
                      handleCompanyChange(company);
                    }} variant="text" key={company.id} fullWidth sx={{
                      'cursor': 'pointer',
                      'textTransform': 'none',
                      'justifyContent': 'flex-start',
                      'borderRadius': '0px',
                      'color': '#1D252D',
                      'borderLeft': '2px solid #fff',
                      'p': 0,
                      //color:companiesSearch && index==0? '#53A6D6':'#1D252D',
                      '&:hover': {
                        backgroundColor: '#fff',
                        color: '#53A6D6',
                        borderLeft: '2px solid #53A6D6'
                      }
                    }}>
                            <Stack sx={{
                        p: 1,
                        color: 'inherit',
                        alignItems: 'center'
                      }} direction="row">
                              <Avatar sx={{
                          backgroundColor: avatarHover == company ? '#53A6D6' : '#BEBEBE'
                        }}>
                                {getInitals(company.name)}
                              </Avatar>
                              <Typography sx={{
                          fontSize: 14,
                          top: '5px',
                          position: 'relative',
                          pl: '10px',
                          color: 'inherit',
                          textAlign: 'left',
                          maxWidth: '266px',
                          wordWrap: 'break-word',
                          overflowWrap: 'break-word',
                          wordBreak: 'break-word'
                        }}>
                                {company.name}
                              </Typography>
                            </Stack>
                          </Button>)}
                      </Stack>
                    </>}
                  <Divider flexItem sx={{
                  pt: 2
                }} />
                </Box>
                <Box display="flex" flexDirection="column">
                  {filteredCompanies.slice(0, 10).map(company => <Button disabled={asCompany.id == company} onMouseEnter={e => setAvatarHover(company)} onMouseLeave={e => setAvatarHover(null)} onClick={() => {
                  handleCompanyChange(company);
                }} variant="text" key={company.id} fullWidth sx={{
                  'cursor': 'pointer',
                  'textTransform': 'none',
                  'justifyContent': 'flex-start',
                  'borderRadius': '0px',
                  'color': '#1D252D',
                  'borderLeft': '2px solid #fff',
                  'p': 0,
                  //color:companiesSearch && index==0? '#53A6D6':'#1D252D',
                  '&:hover': {
                    backgroundColor: '#fff',
                    color: '#53A6D6',
                    borderLeft: '2px solid #53A6D6'
                  }
                }}>
                      <Stack sx={{
                    p: 1,
                    color: 'inherit',
                    alignItems: 'center'
                  }} direction="row">
                        <Avatar sx={{
                      backgroundColor: avatarHover == company ? '#53A6D6' : '#BEBEBE'
                    }}>{getInitals(company.name)}</Avatar>
                        <Typography sx={{
                      fontSize: 14,
                      top: '5px',
                      position: 'relative',
                      pl: '10px',
                      color: 'inherit',
                      textAlign: 'left',
                      maxWidth: '266px',
                      wordWrap: 'break-word',
                      overflowWrap: 'break-word',
                      wordBreak: 'break-word'
                    }}>
                          {company.name}
                        </Typography>
                      </Stack>
                    </Button>)}
                  {!companiesCount && <Box sx={{
                  p: 2
                }}> No results</Box>}
                </Box>
              </Box>
            </Paper>
          </ClickAwayListener>
        </Popper>

        <Popper anchorEl={notificationsAnchorEl} sx={{
        zIndex: 200
      }} open={notificationsOpen} onClose={handleNotificationsClose} placement="bottom-end">
          <ClickAwayListener onClickAway={handleNotificationsClose}>
            <Paper elevation={0} sx={{
            borderRadius: '16px',
            width: '360px',
            overflowY: 'auto',
            overflowX: 'hidden',
            maxHeight: '70vh',
            filter: 'drop-shadow(0px 0px 4px rgba(0,0,0,0.25))',
            mt: 1.5
          }}>
              <Box sx={{
              px: 2,
              py: 1.5
            }}>
                <Typography variant="tableHeader">Notifications</Typography>
              </Box>
              <Divider />
              {notificationsLoading ? <Box sx={{
              px: 2,
              py: 2
            }}>
                  <Typography sx={{
                color: '#616161F2'
              }}>Loading…</Typography>
                </Box> : notifications.length === 0 ? <Box sx={{
              px: 2,
              py: 2
            }}>
                  <Typography sx={{
                color: '#616161F2'
              }}>You're all caught up.</Typography>
                </Box> : notifications.map(notification => <Box key={notification.id} onClick={() => {
              handleNotificationsClose();
              history.push(`/notifications?notification=${notification.id}`);
            }} sx={{
              'px': 2,
              'py': 1.5,
              'cursor': 'pointer',
              'backgroundColor': notification.is_new ? '#F4FAFF' : '#fff',
              'borderBottom': '1px solid #F1F3F4',
              ':hover': {
                backgroundColor: '#DAEFFF'
              }
            }}>
                    <Typography sx={{
                fontWeight: notification.is_new ? 600 : 400
              }}>{notification.topic}</Typography>
                    <Typography variant="caption" sx={{
                color: '#616161F2'
              }}>
                      {new Date(notification.last_triggered_when).toLocaleString()}
                    </Typography>
                  </Box>)}
              <Divider />
              <Box sx={{
              p: 1
            }}>
                <Button fullWidth variant="text" onClick={() => {
                handleNotificationsClose();
                history.push('/notifications');
              }}>
                  View all notifications
                </Button>
              </Box>
            </Paper>
          </ClickAwayListener>
        </Popper>

        <Popper anchorEl={settingsAnchorEl} sx={{
        zIndex: 200
      }} open={settingsOpen} onClose={handleSettingsClose} placement="bottom-end">
          <ClickAwayListener onClickAway={handleSettingsClose}>
            <Paper elevation={0} sx={{
            'borderRadius': '16px',
            'width': '275px',
            'overflowY': 'scroll',
            'overflowX': 'hidden',
            'maxHeight': '90vh',
            'filter': 'drop-shadow(0px 0px 4px rgba(0,0,0,0.25))',
            'mt': 1.5,
            '& .MuiAvatar-root': {
              width: 76,
              height: 76
            },
            '&:before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: 'background.paper',
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 200
            },
            'scrollbarWidth': 'thin',
            '&::-webkit-scrollbar': {
              width: '0.4em'
            },
            '&::-webkit-scrollbar-track': {
              background: '#f1f1f1',
              marginTop: '20px',
              marginBottom: '20px'
            },
            '&::-webkit-scrollbar-thumb': {
              backgroundColor: '#888'
            },
            '&::-webkit-scrollbar-thumb:hover': {
              background: '#555'
            }
          }}>
              <Box sx={{
              py: 2
            }}>
                <Box display="flex" flexDirection="column">
                  <NavLink to={'/users/' + user.id} style={{
                  textDecoration: 'none',
                  color: 'inherit',
                  width: '100%'
                }}>
                    <Box sx={{
                    pt: '20px',
                    alignContent: 'center',
                    alignItems: 'center',
                    position: 'relative',
                    display: 'flex',
                    flexDirection: 'column'
                  }}>
                      <Avatar sx={{
                      bgcolor: '#D9D9D9'
                    }}>
                        {user.first_name[0]} {user.last_name[0]}
                      </Avatar>
                      <Stack sx={{
                      display: 'flex',
                      alignItems: 'center'
                    }} direction="row" spacing="8px">
                        {user?.is_superuser && !impersonatingAsCustomer && <Box sx={{
                        display: 'flex',
                        alignItems: 'center'
                      }}>
                            <Tooltip title="Cinchie Super User">
                              <Box sx={{
                            p: '7px',
                            borderRadius: '8px',
                            backgroundColor: '#C2E7FF'
                          }}>
                                <ShieldPersonIcon fill="#3898D9" />
                              </Box>
                            </Tooltip>
                          </Box>}
                        <Box sx={{
                        display: 'flex',
                        alignItems: 'center'
                      }}>
                          <Typography sx={{
                          maxWidth: '266px',
                          wordWrap: 'break-word',
                          overflowWrap: 'break-word',
                          wordBreak: 'break-word',
                          pt: 2,
                          pb: 1
                        }} variant="tableHeader">
                            {user.first_name} {user.last_name}{' '}
                          </Typography>
                        </Box>
                      </Stack>
                      <Box sx={{
                      display: 'flex',
                      alignItems: 'center'
                    }}>
                        <Typography sx={{
                        maxWidth: '266px',
                        wordWrap: 'break-word',
                        overflowWrap: 'break-word',
                        wordBreak: 'break-word',
                        pb: 2
                      }}>
                          {user.email}
                        </Typography>{' '}
                      </Box>
                    </Box>
                  </NavLink>
                  <Divider />
                  <Stack>
                    <Box sx={{
                    pt: 1
                  }}>
                      {settingsMenu.filter(sub => sub.enabled).map(subItem => <Button disabled={subItem.disabled} variant="text" key={subItem.name} fullWidth onMouseEnter={e => setAvatarHover(subItem.key)} onMouseLeave={e => setAvatarHover(null)} sx={{
                      'cursor': 'pointer',
                      'textTransform': 'none',
                      'justifyContent': 'flex-start',
                      'borderRadius': '0px',
                      'color': '#1D252D',
                      '&:hover': {
                        backgroundColor: '#fff',
                        color: '#53A6D6'
                      }
                    }}>
                            {subItem?.onClick ? <Stack onClick={e => {
                        subItem?.onClick();
                      }} sx={{
                        p: 1,
                        color: 'inherit',
                        alignItems: 'center'
                      }} direction="row">
                                <subItem.icon fill={subItem?.disabled ? '#d3d3d3' : avatarHover == subItem.key ? '#53A6D6' : '#1D252D'} />
                                <Typography variant="tableHeader" sx={{
                          fontSize: 14,
                          mt: '2px',
                          pl: '10px',
                          color: 'inherit'
                        }}>
                                  {subItem.name}
                                </Typography>
                              </Stack> : <NavLink to={subItem.key} style={{
                        textDecoration: 'none',
                        color: 'inherit',
                        width: '100%'
                      }}>
                                <Stack sx={{
                          p: 1,
                          color: 'inherit',
                          alignItems: 'center'
                        }} direction="row">
                                  <Badge badgeContent={subItem?.badge} invisible={!subItem?.badge} sx={{
                            '& .MuiBadge-badge': {
                              color: '#ffffff',
                              backgroundColor: subItem?.badgeColor || '#E35989'
                            }
                          }}>
                                    <subItem.icon fill={avatarHover == subItem.key ? '#53A6D6' : '#1D252D'} />
                                  </Badge>

                                  <Typography variant="tableHeader" sx={{
                            fontSize: 14,
                            mt: '2px',
                            pl: '10px',
                            color: 'inherit'
                          }}>
                                    {subItem.name}
                                  </Typography>
                                </Stack>
                              </NavLink>}
                          </Button>)}
                    </Box>
                  </Stack>
                </Box>
              </Box>
            </Paper>
          </ClickAwayListener>
        </Popper>
        {backdrop && <Box sx={{
        backgroundColor: '#354052',
        opacity: '0.5',
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 899
      }}></Box>}
      </Scoped>
    </>;
};